// extracted by mini-css-extract-plugin
export default {"wrapper":"S3-z","play":"T3-z"};